<template>
<div class="row">
  <div class="col-xs-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          {{ title }}
        </h4>
      </div>
      <div class="card-content">
        <div class="row">
          <div class="col-xs-12">
            <label>Nome</label>
            <input
              type="text"
              v-model="name"
              class="form-control"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <label>Consultar na API do Educacional</label>
            <input
              type="checkbox"
              v-model="apiEdu"
              class="form-checkbox"
            >
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <button
          v-on:click="handleSave"
          class="btn btn-success btn-wd btn-fill"
        >Salvar
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'form-categories',

  data () {
    return {
      name: '',
      apiEdu: false
    }
  },

  computed: {
    ...mapGetters('categories', ['categorie']),
    id: function () {
      return this.$route.params.id
    },

    title: function () {
      return this.id ? 'Editar' : 'Novo'
    }
  },

  methods: {
    ...mapActions('categories', {
      upsert: 'upsert',
      fetchCategorie: 'fetchOne',
      resetOne: 'resetOne'
    }),

    handleSave () {
      return this.upsert(this.setDoc())
        .then(res => {
          this.$router.push({name: 'categories.index'})
        })
    },

    setDoc () {
      const doc = Object.assign({}, this.categorie)
      if (this.id) {
        doc['_id'] = this.id
      }
      doc['name'] = this.name
      doc['apiEdu'] = this.apiEdu
      doc['collection'] = 'categories'
      return doc
    }
  },

  mounted () {
    this.name = ''
    this.apiEdu = false
    this.resetOne()
    if (this.id) {
      this.fetchCategorie(this.id)
        .then(result => {
          this.name = result.name
        })
    }
  }
}
</script>

<style scoped>
  .row {
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ConfigurationsPages/Categories/FormCategories.vue